import React, { useEffect, useLayoutEffect, useState } from 'react'
import './InternalAccessoriesScreen.css'
import { webSerialConnect } from '../../../../redux/actions/index'
import { connect } from 'react-redux'
import io from 'socket.io-client'
import cacheAssets from '../../../../utils/cacheAssets'
import { isZingWithoutRGB } from '../../../../utils/verionControl'
import renderCompImg from '../../../../source/Comp_Img'

import PortConnections from '../../../../Components/Assembly/PortConnections'
/* IMAGES  */
import Modal from 'react-modal'

import { internalaccessoriesObj } from './InternalAccessoriesStorage'
import { Link, useHistory } from 'react-router-dom'
import renderPrgImage from '../../../../source/programImg'
import InternalScPrgm from '../../../../Components/ReusableComponents/PrgmSlider/InternalPrgm/InternalScPrgm'
import { object } from 'prop-types'

import DialogModal from '../../../../Components/ReusableComponents/DialogModal/DialogModal'
import ProgramHeader from '../../../../Components/ReusableComponents/Header/ProgramHeader'
import Footer from '../../../../Components/ReusableComponents/FooterComponent'
import Toast from '../../../../Components/ReusableComponents/UI/Toast'
import { defaultAssemblyPageAi } from '../../../../source/assemblyPageAiData'
import {
    outPutData,
    DEVICE_GROUPS,
    inputRowOneConfig,
    inputRowTwoConfig,
    inputTouchPadConfig,
    inputFourInOneSensorConfig,
    outputRobokiEyesConfig,
    outputPeeCeeRow1Config,
    outputTouchPadConfig,
    outputSmileConfig,
    snackbarConfig,
    snackbarDeviceConfig,
    snackbarBottomConfig,
    snackbarWarningConfig,
    deviceOverlayConfig,
    tostMessages,
} from './internalAccessoriesScreenData'
import renderImage from '../../../../source/importImg'
import { getHederTextArr } from '../../../../utils/langaugeSupport'
import { getDeviceName } from '../../../../utils/utils'
import {
    isInternalAccessoryEnabled,
    getConnectedDeviceImage,
} from '../../../../hooks/useBrandConfig'
import { getConnectedDeviceName } from '../../../../hooks/useBrandConfig'

//const socket = io.connect("http://localhost:3008");

// sessionStorage.setItem(
//   "interAccessoriesData",
//   JSON.stringify(internalaccessoriesObj)
// );

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        height: '23%',
        width: ' 25%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: '5px solid rgb(255,140,25)',
        borderRadius: '20px',
        overflow: 'initial',
        // zIndex: 1,
    },
}

//get the device image url
const getDeviceImageUrl = {
    Ace: `url(${renderPrgImage('pc_v1')})`,
    Roboki: `url(${renderPrgImage('Roboki')})`,
    Autoki: `url(${renderPrgImage('Autoki')})`,
    Atr: `url(${renderPrgImage('Atr')})`,
    Moki: `url(${renderPrgImage('Moki')})`,
    Toki: `url(${renderPrgImage('Toki')})`,
    Poki: `url(${renderPrgImage('pokiBoard')})`,
    // NOTE: quotes are required inside url() because this asset's filename
    // contains spaces ("Mask Group 193@3x.png"); an unquoted url() with spaces
    // is invalid CSS and the background silently fails to load.
    woofKit: `url("${renderImage('woofExpansionKit3')}")`,
}

function InternalAccessoriesScreen_v1(props) {
    console.log(props)

    const deviceVersion = sessionStorage.getItem('deviceVersion') || '1.0.0'
    const connectedDevice = sessionStorage.getItem('connectedDevice') || 'Ace'
    const [humanoidMajor, humanoidMinor] = deviceVersion.split('.').map(Number)
    const isHumanoidWithoutRGB = isZingWithoutRGB(
        connectedDevice,
        deviceVersion
    )
    console.log('[DEBUG][InternalAccessories] connectedDevice:', connectedDevice, '| deviceVersion:', deviceVersion, '| isHumanoidWithoutRGB:', isHumanoidWithoutRGB)
    const history = useHistory()
    const [slideDirection, setSlideDirection] = useState(
        sessionStorage.getItem('slideDirection')
    )
    const [accessories, setAccessories] = useState({
        isDistanceSensors: false,
        isGestureSensor: false,
        isLightSensor: false,
        isColorSensor: false,
        isTemperature: false,
        isBattery: false,
        isAccelerometer: false,
        isMic: false,
        isSwitch1: false,
        isSwitch2: false,
        isIr: false,
        isJoystick: false,
        isTouchZero: false,
        isTouchOne: false,
        isTouchTwo: false,
        isTouchThree: false,
        isTouchZeroOutput: false,
        isTouchOneOutput: false,
        isTouchTwoOutput: false,
        isTouchThreeOutput: false,
        isEYES: false,
        isbuzzer: false,
        isSmileOne: false,
        isSmileTwo: false,
        isSmileThree: false,
        isSmileFour: false,
        isLeftEye: false,
        isRightEye: false,
        isAtrMotor1: false,
        isAtrMotor2: false,
        isAtrMotor3: false,
    })
    const updateAccessory = (patch) =>
        setAccessories((prev) => ({ ...prev, ...patch }))
    const {
        isDistanceSensors,
        isGestureSensor,
        isLightSensor,
        isColorSensor,
        isTemperature,
        isBattery,
        isAccelerometer,
        isMic,
        isSwitch1,
        isSwitch2,
        isIr,
        isJoystick,
        isTouchZero,
        isTouchOne,
        isTouchTwo,
        isTouchThree,
        isTouchZeroOutput,
        isTouchOneOutput,
        isTouchTwoOutput,
        isTouchThreeOutput,
        isEYES,
        isbuzzer,
        isSmileOne,
        isSmileTwo,
        isSmileThree,
        isSmileFour,
        isLeftEye,
        isRightEye,
        isAtrMotor1,
        isAtrMotor2,
        isAtrMotor3,
    } = accessories

    const [erasedProgram, setErasedProgram] = useState(false)

    const [isusb, setUsb] = useState(false)
    const [reloaded, setReloaded] = useState(false)

    const [showFeedback, isShowFeedback] = useState(false)
    const [feedbackMsg, setFeedbackMsg] = useState('')

    const languageName = props.indexData.device.language

    const isPlayShield = sessionStorage.getItem('shield') === 'true' || false
    const isPeeCeeATR = sessionStorage.getItem('peeCeeATR') === 'true' || false
    const assembly = JSON.parse(sessionStorage.getItem('assembly'))
    const isM1DOccupied = assembly.PortConnections.M1 || false
    const isM2DOccupied = assembly.PortConnections.M2 || false
    const isM3DOccupied = assembly.PortConnections.M3 || false
    const isM4DOccupied = assembly.PortConnections.M4 || false
    const isM1 = sessionStorage.getItem('M1') === 'true' || false
    const isM2 = sessionStorage.getItem('M2') === 'true' || false
    const isM3 = sessionStorage.getItem('M3') === 'true' || false
    const isM4 = sessionStorage.getItem('M4') === 'true' || false

    const mode = sessionStorage.getItem('programMode')


    const styleDevicePC = {
        backgroundImage: (() => {
            const brandDeviceImg = getConnectedDeviceImage(
                connectedDevice,
                sessionStorage.getItem('deviceVersion') || '1'
            )
            return brandDeviceImg
                ? `url(${brandDeviceImg})`
                : getDeviceImageUrl?.[connectedDevice] ||
                      `url(${renderPrgImage('pc_v1')})`
        })(),
        backgroundRepeat: 'no-repeat',
        backgroundSize:
            connectedDevice === 'Ace'
                ? '86% 96%'
                : ['woofKit'].includes(connectedDevice)
                  ? '100% 90%'
                  : 'contain',
        backgroundPosition: '50% 50%',
        zIndex: 110,
        position: 'relative',
        aspectRatio: '1 / 1',
    }

    const stateMap = accessories

    const FOUR_IN_ONE_KEYS = [
        'isDistanceSensors',
        'isGestureSensor',
        'isLightSensor',
        'isColorSensor',
    ]

    useLayoutEffect(() => {
        const ia = props.indexData.concept.internalaccessories
        const synced = {}
        let changed = false
        Object.keys(accessories).forEach((key) => {
            const val = FOUR_IN_ONE_KEYS.includes(key)
                ? ia.Four_in_one_sensor[key]
                : ia[key]
            synced[key] = val
            if (val !== accessories[key]) changed = true
        })
        if (changed) setAccessories(synced)
    })
    useEffect(() => {
        console.log('PROPS', props.location.data)

        let hhh = JSON.parse(sessionStorage.getItem('SavedGDriveData'))
        let names = JSON.parse(sessionStorage.getItem('saveProps')) || null
        if (hhh != null && names != null) {
            for (let i = 0; i < hhh.length; i++) {
                if (names.name == hhh[i].name) {
                    sessionStorage.setItem('pip', true)
                    sessionStorage.setItem('name', names.name)
                    console.log(
                        'KK',
                        hhh[i].concept.internalaccessories.isTouchOne
                    )
                    Object.keys(hhh[i]).map((key, value) => {
                        console.log('KEYS', key, value)
                        switch (key) {
                            case 'concept': {
                                sessionStorage.setItem(
                                    'concept',
                                    JSON.stringify(hhh[i].concept)
                                )
                            }
                            case 'assembly': {
                                sessionStorage.setItem(
                                    'assembly',
                                    JSON.stringify(hhh[i].assembly)
                                )
                            }
                            case 'logic': {
                                sessionStorage.setItem(
                                    'logic',
                                    JSON.stringify(hhh[i].logic)
                                )
                            }
                            case 'programEnd': {
                                sessionStorage.setItem(
                                    'programEnd',
                                    JSON.stringify(hhh[i].programEnd)
                                )
                            }
                            case 'SelectedStatus': {
                                sessionStorage.setItem(
                                    'SelectedStatus',
                                    JSON.stringify(hhh[i].SelectedStatus)
                                )
                            }
                        }
                    })
                    if (
                        sessionStorage.getItem('internalAcessoriesReload') ==
                        'true'
                    ) {
                        sessionStorage.setItem(
                            'internalAcessoriesReload',
                            false
                        )
                        window.location.reload()
                    }
                }
            }
        }
    })
    //useEffect to connect to pc automatically
    useEffect(async () => {
        navigator.serial.addEventListener('connect', (e) => {
            setUsb(true)
            var user = 1
            sessionStorage.setItem('user', JSON.stringify(user))
            if (window.location.pathname === '/deviceSelection') {
                sessionStorage.setItem('autoCunnection', 'true')
            }
        })

        navigator.serial.addEventListener('disconnect', async (e) => {
            setUsb(false)
            var user = 0
            sessionStorage.setItem('user', JSON.stringify(user))
            const p_Port = props.indexData.webSerial
            try {
                await p_Port.close()
            } catch (e) {}
        })
    })
    const removeFromProgram = async (e, obj, resetValue) => {
        if (obj.length == 0) return
        for (var key in obj) {
            if (
                obj[key].type == 'hardware' ||
                obj[key].type == 'output' ||
                obj[key].type == 'variable_output'
            ) {
                if (e.slice(0, 5) === 'value') {
                    obj[key].state[e] =
                        resetValue === undefined ? 0 : resetValue
                } else {
                    obj[key].state[e] = false
                }
            }
            if (
                obj[key].type == 'condition' ||
                obj[key].type == 'if' ||
                obj[key].type == 'else' ||
                obj[key].type == 'sensor' ||
                obj[key].type == 'variable' ||
                obj[key].type == 'loop'
            ) {
                await removeFromProgram(e, obj[key].subprogram, resetValue)
            }
        }
    }

    const OLED_TEXT_ROWS = ['OLEDOne', 'OLEDTwo', 'OLEDThree']
    const OLED_SELECT_ROWS = ['OLEDFour', 'OLEDFive']

    const resetOledProgramData = async () => {
        const program = props.indexData.logic.program
        for (const row of OLED_TEXT_ROWS) {
            await removeFromProgram(`assign${row}`, program)
            await removeFromProgram(`value${row}`, program, '')
        }
        for (const row of OLED_SELECT_ROWS) {
            await removeFromProgram(`assign${row}`, program)
            await removeFromProgram(`value${row}`, program, 'default')
        }
    }

    const clearOledSensorSelection = (sensorKey) => {
        const clear = (nodes) => {
            if (!nodes || nodes.length == 0) return
            for (const key in nodes) {
                const nodeState = nodes[key].state
                if (nodeState) {
                    ;[...OLED_TEXT_ROWS, 'OLEDFour'].forEach((row) => {
                        if (nodeState[`value${row}`] === sensorKey) {
                            nodeState[`value${row}`] = 'default'
                            nodeState[`assign${row}`] = false
                        }
                    })
                }
                if (nodes[key].subprogram) clear(nodes[key].subprogram)
            }
        }
        clear(props.indexData.logic.program)
    }
    //useeffect fo setting usb icon
    useEffect(() => {
        const p_Port = props.indexData.webSerial
        if (p_Port.readable != null) {
            let v = 1
            sessionStorage.setItem('user', JSON.stringify(v))
        }
    }, [])

    const clearFlowChartIfPannelData = (flowData, sensor) => {
        if (
            mode === 'flowchartBased' &&
            ![undefined, null].includes(flowData)
        ) {
            Object.values(JSON.parse(flowData)).map((value) => {
                if (
                    value.data !== undefined &&
                    value.data.specificElType === 'if'
                ) {
                    var id = value.id
                    if (
                        sensor.includes(sessionStorage.getItem(`ifSelect${id}`))
                    ) {
                        sessionStorage.setItem(`ifValue${id}`, 0)
                        sessionStorage.setItem(`ifValue2${id}`, 0)
                        sessionStorage.setItem(`gt${id}`, false)
                        sessionStorage.setItem(`lt${id}`, false)
                        sessionStorage.setItem(`bw${id}`, false)
                        sessionStorage.setItem(`eq${id}`, false)
                        sessionStorage.setItem(`ne${id}`, false)
                    }
                }
            })
        }
    }

    const showSnackbar = (elementId) => {
        setTimeout(() => {
            const el = document.getElementById(elementId)
            const message = el ? (el.textContent || '').trim() : ''
            if (!message) return
            setFeedbackMsg(message)
            isShowFeedback(true)
        }, 0)
    }

    const clearLogicSensorData = (sources) => {
        props.indexData.logic.program.map((data) => {
            if (data.type === 'sensor' && sources.includes(data.state.source)) {
                data.state.source = ''
                data.state.value = 0
                data.state.value2 = 0
                data.state.condition = ''
            }
        })
    }

    const clearFlowchartOutputSessions = (prefixes) => {
        if (sessionStorage.getItem('programMode') !== 'flowchartBased') return
        const flowElements =
            JSON.parse(sessionStorage.getItem('flowchart-elements')) || null
        if (flowElements === null) return
        flowElements.map((value) => {
            if (value.type === 'output') {
                prefixes.forEach(([chkKey, valKey]) => {
                    sessionStorage.setItem(`${chkKey}${value.id}`, false)
                    sessionStorage.setItem(`${valKey}${value.id}`, 0)
                })
            }
        })
    }

    const resetHardwareState = (assignKeys) => {
        for (var key in props.indexData.logic.program) {
            if (props.indexData.logic.program[key].type == 'hardware') {
                assignKeys.forEach((assignKey) => {
                    props.indexData.logic.program[key].state[assignKey] = false
                })
            }
        }
    }

    const fourInOneSensorMap = {
        distancesensors: {
            stateKey: 'isDistanceSensors',
            sessionKey: 'isDistanceSensors',
            deactivateSources: ['4-IN-1SENSOR→DISTANCE'],
            flowchartSensors: ['distanceSensor'],
            snackbarId: 'snackbar18',
        },
        gesturesensor: {
            stateKey: 'isGestureSensor',
            sessionKey: 'isGestureSensor',
            deactivateSources: ['4-IN-1SENSOR→GESTURE'],
            flowchartSensors: ['gestureSensor'],
            snackbarId: 'snackbar19',
        },
        lightsensor: {
            stateKey: 'isLightSensor',
            sessionKey: 'isLightSensor',
            deactivateSources: ['4-IN-1SENSOR→LIGHT'],
            flowchartSensors: ['lightSensor'],
            snackbarId: 'snackbar20',
        },
        colorsensor: {
            stateKey: 'isColorSensor',
            sessionKey: 'isColorSensor',
            deactivateSources: [
                '4-IN-1SENSOR→RED',
                '4-IN-1SENSOR→BLUE',
                '4-IN-1SENSOR→GREEN',
            ],
            flowchartSensors: [
                'colorSensorRed',
                'colorSensorGreen',
                'colorSensorBlue',
            ],
            snackbarId: 'snackbar21',
        },
    }

    const allFourInOneSensorKeys = [
        'isDistanceSensors',
        'isGestureSensor',
        'isLightSensor',
        'isColorSensor',
    ]

    const handleFounInOneSensor = (e) => {
        const assembly = JSON.parse(sessionStorage.getItem('assembly'))
        if (
            assembly.PortConnections.D !== null &&
            assembly.PortConnections.D.type !== 'OLED'
        ) {
            setFeedbackMsg(
                'D port should be empty or can be connected with OLED inorder to enable FourInSensor'
            )
            isShowFeedback(true)
            return
        }

        const config = fourInOneSensorMap[e.target.alt]
        if (!config) return

        const isActive = stateMap[config.stateKey]

        if (isActive) {
            internalaccessoriesObj.Four_in_one_sensor[config.stateKey] = false
            props.selecteComponent({ [config.stateKey]: false })
            sessionStorage.setItem(config.sessionKey, false)
            props.indexData.logic.program.map((data) => {
                if (
                    data.type === 'sensor' &&
                    config.deactivateSources.includes(
                        data.state.source.split(' ').join('')
                    )
                ) {
                    data.state.source = ''
                    data.state.value = 0
                    data.state.value2 = 0
                    data.state.condition = ''
                }
            })
            clearFlowChartIfPannelData(
                sessionStorage.getItem('flowchart-elements'),
                config.flowchartSensors
            )
            props.logicComponent(props.indexData.logic)
            updateAccessory({ [config.stateKey]: false })
        } else {
            const reduxPayload = {}
            allFourInOneSensorKeys.forEach((key) => {
                reduxPayload[key] = key === config.stateKey
            })
            props.selecteComponent(reduxPayload)
            props.indexData.logic.program.map((data) => {
                if (
                    data.type === 'sensor' &&
                    data.state.source.includes('4-IN-1 SENSOR')
                ) {
                    data.state.source = ''
                    data.state.value = 0
                    data.state.value2 = 0
                    data.state.condition = ''
                }
            })
            props.logicComponent(props.indexData.logic)
            const statePatch = {}
            allFourInOneSensorKeys.forEach((key) => {
                const val = key === config.stateKey
                internalaccessoriesObj.Four_in_one_sensor[key] = val
                statePatch[key] = val
                sessionStorage.setItem(key, val)
            })
            updateAccessory(statePatch)
        }
        showSnackbar(config.snackbarId)
    }

    const handleEventsClick = async (e) => {
        sessionStorage.setItem('isSave', JSON.stringify(false))
        switch (e.target.alt) {
            case 'mic': {
                if (isMic) {
                    internalaccessoriesObj.isMic = false
                    props.selecteComponent({ isMic: false })
                    sessionStorage.setItem('isMic', false)
                    updateAccessory({ isMic: false })
                    clearLogicSensorData(['MICROPHONE'])
                    clearFlowChartIfPannelData(
                        sessionStorage.getItem('flowchart-elements'),
                        ['microphone']
                    )
                    props.logicComponent(props.indexData.logic)
                } else {
                    internalaccessoriesObj.isMic = true
                    props.selecteComponent({ isMic: true })
                    sessionStorage.setItem('isMic', true)
                    updateAccessory({ isMic: true })
                }
                showSnackbar('snackbar1')
                break
            }

            case 'temperature': {
                if (isTemperature) {
                    internalaccessoriesObj.isTemperature = false
                    props.selecteComponent({ isTemperature: false })
                    updateAccessory({ isTemperature: false })
                    sessionStorage.setItem('isTemperature', false)
                    clearLogicSensorData(['TEMPERATURE'])
                    clearFlowChartIfPannelData(
                        sessionStorage.getItem('flowchart-elements'),
                        ['temperature']
                    )
                    props.logicComponent(props.indexData.logic)
                } else {
                    internalaccessoriesObj.isTemperature = true
                    props.selecteComponent({ isTemperature: true })
                    updateAccessory({ isTemperature: true })
                    sessionStorage.setItem('isTemperature', true)
                }
                showSnackbar('snackbar2')
                break
            }

            case 'battery': {
                if (isBattery) {
                    internalaccessoriesObj.isBattery = false
                    props.selecteComponent({ isBattery: false })
                    updateAccessory({ isBattery: false })
                    sessionStorage.setItem('isBattery', false)
                    clearLogicSensorData(['BATTERY'])
                    clearFlowChartIfPannelData(
                        sessionStorage.getItem('flowchart-elements'),
                        ['battery']
                    )
                } else {
                    internalaccessoriesObj.isBattery = true
                    props.selecteComponent({ isBattery: true })
                    updateAccessory({ isBattery: true })
                    sessionStorage.setItem('isBattery', true)
                    props.logicComponent(props.indexData.logic)
                }
                showSnackbar('snackbar3')
                break
            }

            case 'accelerometer': {
                if (
                    assembly.PortConnections.D !== null &&
                    assembly.PortConnections.D.type !== 'OLED'
                ) {
                    setFeedbackMsg(
                        'D port should be empty or can be connected with OLED inorder to enable Accelerometer'
                    )
                    isShowFeedback(true)
                    return
                }
                if (isAccelerometer) {
                    internalaccessoriesObj.isAccelerometer = false
                    props.selecteComponent({ isAccelerometer: false })
                    updateAccessory({ isAccelerometer: false })
                    sessionStorage.setItem('isAccelerometer', false)
                    clearLogicSensorData([
                        'ACCELEROMETER_X',
                        'ACCELEROMETER_Y',
                        'ACCELEROMETER_Z',
                        'GYRO_X',
                        'GYRO_Y',
                        'GYRO_Z',
                    ])
                    clearFlowChartIfPannelData(
                        sessionStorage.getItem('flowchart-elements'),
                        [
                            'accelerometer_x',
                            'accelerometer_y',
                            'accelerometer_z',
                            'gyro_x',
                            'gyro_y',
                            'gyro_z',
                        ]
                    )
                    props.logicComponent(props.indexData.logic)
                } else {
                    internalaccessoriesObj.isAccelerometer = true
                    props.selecteComponent({ isAccelerometer: true })
                    updateAccessory({ isAccelerometer: true })
                    sessionStorage.setItem('isAccelerometer', true)
                }
                showSnackbar('snackbar4')
                break
            }

            case 'touch0': {
                if (JSON.parse(sessionStorage.getItem('S1'))) {
                    showSnackbar('snackbar3_A1')
                    return
                }
                if (isPlayShield) {
                    setFeedbackMsg(
                        'Please disable playshield in assembly screen to enable touch0'
                    )
                    isShowFeedback(true)
                    break
                }
                if (isPeeCeeATR) {
                    setFeedbackMsg(
                        'Please disable peeCeeATR in assembly screen to enable touch0'
                    )
                    isShowFeedback(true)
                    break
                }
                if (isTouchZero) {
                    props.selecteComponent({ isTouchZero: false })
                    internalaccessoriesObj.isTouchZero = false
                    updateAccessory({ isTouchZero: false })
                    sessionStorage.setItem('isTouchZero', false)
                    clearLogicSensorData(['TouchZero'])
                    clearFlowChartIfPannelData(
                        sessionStorage.getItem('flowchart-elements'),
                        ['touchZero']
                    )
                    props.logicComponent(props.indexData.logic)
                } else {
                    props.selecteComponent({
                        isTouchZero: true,
                        isTouchZeroOutput: false,
                    })
                    internalaccessoriesObj.isTouchZero = true
                    internalaccessoriesObj.isTouchZeroOutput = false
                    updateAccessory({
                        isTouchZero: true,
                        isTouchZeroOutput: false,
                    })
                    sessionStorage.setItem('isTouchZero', true)
                    sessionStorage.setItem('isTouchZeroOutput', false)
                }
                showSnackbar('snackbar5')
                break
            }

            case 'touch1': {
                if (JSON.parse(sessionStorage.getItem('S2'))) {
                    showSnackbar('snackbar7_B1')
                    return
                }
                if (isPlayShield) {
                    setFeedbackMsg(
                        'Please disable playshield in assembly screen to enable touch1'
                    )
                    isShowFeedback(true)
                    break
                }
                if (isPeeCeeATR) {
                    setFeedbackMsg(
                        'Please disable peeCeeATR in assembly screen to enable touch0'
                    )
                    isShowFeedback(true)
                    break
                }
                if (isTouchOne) {
                    props.selecteComponent({ isTouchOne: false })
                    internalaccessoriesObj.isTouchOne = false
                    updateAccessory({ isTouchOne: false })
                    sessionStorage.setItem('isTouchOne', false)
                    clearLogicSensorData(['TouchOne'])
                    clearFlowChartIfPannelData(
                        sessionStorage.getItem('flowchart-elements'),
                        ['touchOne']
                    )
                    props.logicComponent(props.indexData.logic)
                } else {
                    props.selecteComponent({
                        isTouchOne: true,
                        isTouchOneOutput: false,
                    })
                    internalaccessoriesObj.isTouchOne = true
                    internalaccessoriesObj.isTouchOneOutput = false
                    updateAccessory({
                        isTouchOne: true,
                        isTouchOneOutput: false,
                    })
                    sessionStorage.setItem('isTouchOne', true)
                    sessionStorage.setItem('isTouchOneOutput', false)
                }
                showSnackbar('snackbar6')
                break
            }

            case 'touch2': {
                if (isPlayShield) {
                    setFeedbackMsg(
                        'Please disable playshield in assembly screen to enable touch2'
                    )
                    isShowFeedback(true)
                    break
                }
                if (isPeeCeeATR) {
                    setFeedbackMsg(
                        'Please disable peeCeeATR in assembly screen to enable touch0'
                    )
                    isShowFeedback(true)
                    break
                }
                if (isTouchTwo) {
                    props.selecteComponent({ isTouchTwo: false })
                    internalaccessoriesObj.isTouchTwo = false
                    updateAccessory({ isTouchTwo: false })
                    sessionStorage.setItem('isTouchTwo', false)
                    clearLogicSensorData(['TouchTwo'])
                    clearFlowChartIfPannelData(
                        sessionStorage.getItem('flowchart-elements'),
                        ['touchTwo']
                    )
                    props.logicComponent(props.indexData.logic)
                } else {
                    props.selecteComponent({
                        isTouchTwo: true,
                        isTouchTwoOutput: false,
                    })
                    internalaccessoriesObj.isTouchTwo = true
                    internalaccessoriesObj.isTouchTwoOutput = false
                    updateAccessory({
                        isTouchTwo: true,
                        isTouchTwoOutput: false,
                    })
                    sessionStorage.setItem('isTouchTwo', true)
                    sessionStorage.setItem('isTouchTwoOutput', false)
                }
                showSnackbar('snackbar7')
                break
            }

            case 'touch3': {
                if (isPlayShield) {
                    setFeedbackMsg(
                        'Please disable playshield in assembly screen to enable touch3'
                    )
                    isShowFeedback(true)
                    break
                }
                if (isPeeCeeATR) {
                    setFeedbackMsg(
                        'Please disable peeCeeATR in assembly screen to enable touch0'
                    )
                    isShowFeedback(true)
                    break
                }
                if (isTouchThree) {
                    props.selecteComponent({ isTouchThree: false })
                    internalaccessoriesObj.isTouchThree = false
                    updateAccessory({ isTouchThree: false })
                    sessionStorage.setItem('isTouchThree', false)
                    clearLogicSensorData(['TouchThree'])
                    clearFlowChartIfPannelData(
                        sessionStorage.getItem('flowchart-elements'),
                        ['touchThree']
                    )
                    props.logicComponent(props.indexData.logic)
                } else {
                    props.selecteComponent({
                        isTouchThree: true,
                        isTouchThreeOutput: false,
                    })
                    internalaccessoriesObj.isTouchThree = true
                    internalaccessoriesObj.isTouchThreeOutput = false
                    updateAccessory({
                        isTouchThree: true,
                        isTouchThreeOutput: false,
                    })
                    sessionStorage.setItem('isTouchThree', true)
                    sessionStorage.setItem('isTouchThreeOutput', false)
                }
                showSnackbar('snackbar8')
                break
            }

            case 'touch0Output': {
                if (JSON.parse(sessionStorage.getItem('S1'))) {
                    showSnackbar('snackbar3_A1')
                    return
                }
                if (isPlayShield) {
                    setFeedbackMsg(
                        'Please disable playshield in assembly screen to enable touch0Output'
                    )
                    isShowFeedback(true)
                    break
                }
                if (isPeeCeeATR) {
                    setFeedbackMsg(
                        'Please disable peeCeeATR in assembly screen to enable touch0'
                    )
                    isShowFeedback(true)
                    break
                }
                if (isTouchZeroOutput) {
                    await removeFromProgram(
                        'assignTouchZeroOutput',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueTouchZeroOutput',
                        props.indexData.logic.program
                    )
                    props.selecteComponent({ isTouchZeroOutput: false })
                    internalaccessoriesObj.isTouchZeroOutput = false
                    updateAccessory({ isTouchZeroOutput: false })
                    sessionStorage.setItem('isTouchZeroOutput', false)
                    clearFlowchartOutputSessions([['t0Chk', 't0']])
                } else {
                    props.selecteComponent({
                        isTouchZeroOutput: true,
                        isTouchZero: false,
                    })
                    clearLogicSensorData(['TouchZero'])
                    props.logicComponent(props.indexData.logic)
                    resetHardwareState(['assignTouchZeroOutput'])
                    //to change props in logic.program for correct simulation
                    for (var key in props.indexData.logic.program) {
                        //console.log("halo key", props.indexData.logic.program[key]);
                        if (
                            props.indexData.logic.program[key].type ==
                            'hardware'
                        ) {
                            props.indexData.logic.program[
                                key
                            ].state.assignTouchZeroOutput = false
                        }
                    } //for sim
                    const device = sessionStorage.getItem('connectedDevice')

                    internalaccessoriesObj.isTouchZeroOutput = true
                    internalaccessoriesObj.isTouchZero = false
                    updateAccessory({
                        isTouchZeroOutput: true,
                        isTouchZero: false,
                    })
                    sessionStorage.setItem('isTouchZeroOutput', true)
                    sessionStorage.setItem('isTouchZero', false)
                }
                showSnackbar('snackbar9')
                break
            }

            case 'touch1Output': {
                if (JSON.parse(sessionStorage.getItem('S2'))) {
                    showSnackbar('snackbar7_B1')
                    return
                }
                if (isPlayShield) {
                    setFeedbackMsg(
                        'Please disable playshield in assembly screen to enable touch1Output'
                    )
                    isShowFeedback(true)
                    break
                }
                if (isPeeCeeATR) {
                    setFeedbackMsg(
                        'Please disable peeCeeATR in assembly screen to enable touch0'
                    )
                    isShowFeedback(true)
                    break
                }
                if (isTouchOneOutput) {
                    internalaccessoriesObj.isTouchOneOutput = false
                    updateAccessory({ isTouchOneOutput: false })
                    sessionStorage.setItem('isTouchOneOutput', false)
                    await removeFromProgram(
                        'assignTouchOneOutput',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueTouchOneOutput',
                        props.indexData.logic.program
                    )
                    props.selecteComponent({ isTouchOneOutput: false })
                    clearFlowchartOutputSessions([['t1Chk', 't1']])
                } else {
                    props.selecteComponent({
                        isTouchOneOutput: true,
                        isTouchOne: false,
                    })
                    clearLogicSensorData(['TouchOne'])
                    props.logicComponent(props.indexData.logic)
                    internalaccessoriesObj.isTouchOneOutput = true
                    internalaccessoriesObj.isTouchOne = false
                    resetHardwareState(['assignTouchOneOutput'])
                    updateAccessory({
                        isTouchOneOutput: true,
                        isTouchOne: false,
                    })
                    sessionStorage.setItem('isTouchOneOutput', true)
                    sessionStorage.setItem('isTouchOne', false)
                }
                showSnackbar('snackbar10')
                break
            }

            case 'touch2Output': {
                if (isPlayShield) {
                    setFeedbackMsg(
                        'Please disable playshield in assembly screen to enable touch2Output'
                    )
                    isShowFeedback(true)
                    break
                }
                if (isPeeCeeATR) {
                    setFeedbackMsg(
                        'Please disable peeCeeATR in assembly screen to enable touch0'
                    )
                    isShowFeedback(true)
                    break
                }
                if (isTouchTwoOutput) {
                    internalaccessoriesObj.isTouchTwoOutput = false
                    updateAccessory({ isTouchTwoOutput: false })
                    sessionStorage.setItem('isTouchTwoOutput', false)
                    await removeFromProgram(
                        'assignTouchTwoOutput',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueTouchTwoOutput',
                        props.indexData.logic.program
                    )
                    props.selecteComponent({ isTouchTwoOutput: false })
                    clearFlowchartOutputSessions([['t2Chk', 't2']])
                } else {
                    props.selecteComponent({
                        isTouchTwoOutput: true,
                        isTouchTwo: false,
                    })
                    clearLogicSensorData(['TouchTwo'])
                    props.logicComponent(props.indexData.logic)
                    internalaccessoriesObj.isTouchTwoOutput = true
                    internalaccessoriesObj.isTouchTwo = false
                    resetHardwareState(['assignTouchTwoOutput'])
                    updateAccessory({
                        isTouchTwoOutput: true,
                        isTouchTwo: false,
                    })
                    sessionStorage.setItem('isTouchTwoOutput', true)
                    sessionStorage.setItem('isTouchTwo', false)
                }
                showSnackbar('snackbar11')
                break
            }

            case 'touch3Output': {
                if (isPlayShield) {
                    setFeedbackMsg(
                        'Please disable playshield in assembly screen to enable touch1Output'
                    )
                    isShowFeedback(true)
                    break
                }
                if (isPeeCeeATR) {
                    setFeedbackMsg(
                        'Please disable peeCeeATR in assembly screen to enable touch0'
                    )
                    isShowFeedback(true)
                    break
                }
                if (isTouchThreeOutput) {
                    internalaccessoriesObj.isTouchThreeOutput = false
                    updateAccessory({ isTouchThreeOutput: false })
                    sessionStorage.setItem('isTouchThreeOutput', false)
                    await removeFromProgram(
                        'assignTouchThreeOutput',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueTouchThreeOutput',
                        props.indexData.logic.program
                    )
                    props.selecteComponent({ isTouchThreeOutput: false })
                    clearFlowchartOutputSessions([['t3Chk', 't3']])
                } else {
                    props.selecteComponent({
                        isTouchThreeOutput: true,
                        isTouchThree: false,
                    })
                    clearLogicSensorData(['TouchThree'])
                    props.logicComponent(props.indexData.logic)
                    internalaccessoriesObj.isTouchThreeOutput = true
                    internalaccessoriesObj.isTouchThree = false
                    resetHardwareState(['assignTouchThreeOutput'])
                    updateAccessory({
                        isTouchThreeOutput: true,
                        isTouchThree: false,
                    })
                    sessionStorage.setItem('isTouchThreeOutput', true)
                    sessionStorage.setItem('isTouchThree', false)
                }
                showSnackbar('snackbar22')
                break
            }

            case 'isEYES': {
                if (isEYES) {
                    internalaccessoriesObj.isEYES = false
                    updateAccessory({ isEYES: false })
                    sessionStorage.setItem('isInternalEye', false)
                    for (let i = 1; i <= 12; i++) {
                        await removeFromProgram(
                            `assignEye${i}`,
                            props.indexData.logic.program
                        )
                        await removeFromProgram(
                            `valueEyeR${i}`,
                            props.indexData.logic.program
                        )
                        await removeFromProgram(
                            `valueEyeG${i}`,
                            props.indexData.logic.program
                        )
                        await removeFromProgram(
                            `valueEyeB${i}`,
                            props.indexData.logic.program
                        )
                    }
                    props.selecteComponent({ isEYES: false })
                } else {
                    props.selecteComponent({ isEYES: true })
                    internalaccessoriesObj.isEYES = true
                    resetHardwareState(['assignEye'])
                    updateAccessory({ isEYES: true })
                    sessionStorage.setItem('isInternalEye', true)
                    if (
                        sessionStorage.getItem('programMode') ===
                        'flowchartBased'
                    ) {
                        const flowElements =
                            JSON.parse(
                                sessionStorage.getItem('flowchart-elements')
                            ) || null
                        if (flowElements !== null) {
                            const defaultEyeRGB = Array.from(
                                { length: 12 },
                                () => ({
                                    isSelected: false,
                                    valR: 0,
                                    valG: 0,
                                    valB: 0,
                                })
                            )
                            flowElements.map((value) => {
                                if (value.type === 'output') {
                                    sessionStorage.setItem(
                                        `valRGBEye${value.id}`,
                                        JSON.stringify(defaultEyeRGB)
                                    )
                                }
                            })
                        }
                    }
                }
                showSnackbar('snackbar12')
                break
            }

            case 'buzzer': {
                if (isbuzzer) {
                    internalaccessoriesObj.isbuzzer = false
                    updateAccessory({ isbuzzer: false })
                    sessionStorage.setItem('isBuzzer', false)
                    await removeFromProgram(
                        'assignBuzzer',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'assignBuzzerFrequency',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'assignBuzzerTone',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueBuzzerFrequency',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueBuzzerTone',
                        props.indexData.logic.program
                    )
                    props.selecteComponent({ isbuzzer: false })
                    clearFlowchartOutputSessions([
                        ['toneBuzzCheck', 'toneBuzzCheck'],
                        ['frequencyBuzzCheck', 'frequencyBuzzCheck'],
                        ['buzzChk', 'buzz'],
                    ])
                } else {
                    props.selecteComponent({ isbuzzer: true })
                    internalaccessoriesObj.isbuzzer = true
                    resetHardwareState(['assignBuzzer'])
                    updateAccessory({ isbuzzer: true })
                    sessionStorage.setItem('isBuzzer', true)
                }
                showSnackbar('snackbar13')
                break
            }

            case 'smile1': {
                if (isM1) {
                    setFeedbackMsg(' Disable L1 to Enable Smile 1')
                    isShowFeedback(true)
                    return
                }
                if (isM1DOccupied) {
                    setFeedbackMsg(
                        'Disconnect the sensor from port M1 to enable smile1'
                    )
                    isShowFeedback(true)
                    return
                }
                if (isSmileOne) {
                    internalaccessoriesObj.isSmileOne = false
                    updateAccessory({ isSmileOne: false })
                    sessionStorage.setItem('isSmileOne', false)
                    await removeFromProgram(
                        'assignSmileOne',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueSmileOne',
                        props.indexData.logic.program
                    )
                    props.selecteComponent({ isSmileOne: false })
                    clearFlowchartOutputSessions([['s1Chk', 'sm1']])
                } else {
                    props.selecteComponent({ isSmileOne: true })
                    internalaccessoriesObj.isSmileOne = true
                    updateAccessory({ isSmileOne: true })
                    sessionStorage.setItem('isSmileOne', true)
                    resetHardwareState(['assignSmileOne'])
                }
                showSnackbar('snackbar14')
                break
            }

            case 'smile2': {
                if (isM2) {
                    setFeedbackMsg(' Disable L2 to Enable Smile 3')
                    isShowFeedback(true)
                    return
                }
                if (isM2DOccupied) {
                    setFeedbackMsg(
                        'Disconnect the sensor from port M1 to enable smile2'
                    )
                    isShowFeedback(true)
                    return
                }
                if (isSmileTwo) {
                    internalaccessoriesObj.isSmileTwo = false
                    updateAccessory({ isSmileTwo: false })
                    sessionStorage.setItem('isSmileTwo', false)
                    await removeFromProgram(
                        'assignSmileTwo',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueSmileTwo',
                        props.indexData.logic.program
                    )
                    props.selecteComponent({ isSmileTwo: false })
                    clearFlowchartOutputSessions([['s2Chk', 'sm2']])
                } else {
                    props.selecteComponent({ isSmileTwo: true })
                    internalaccessoriesObj.isSmileTwo = true
                    resetHardwareState(['assignSmileTwo'])
                    updateAccessory({ isSmileTwo: true })
                    sessionStorage.setItem('isSmileTwo', true)
                }
                showSnackbar('snackbar15')
                break
            }

            case 'smile3': {
                if (isM3) {
                    setFeedbackMsg(' Disable L3 to Enable Smile 3')
                    isShowFeedback(true)
                    return
                }
                if (isM3DOccupied) {
                    setFeedbackMsg(
                        'Disconnect the sensor from port M2 to enable smile2'
                    )
                    isShowFeedback(true)
                    return
                }
                if (isSmileThree) {
                    internalaccessoriesObj.isSmileThree = false
                    updateAccessory({ isSmileThree: false })
                    sessionStorage.setItem('isSmileThree', false)
                    await removeFromProgram(
                        'assignSmileThree',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueSmileThree',
                        props.indexData.logic.program
                    )
                    props.selecteComponent({ isSmileThree: false })
                    clearFlowchartOutputSessions([['s3Chk', 'sm3']])
                } else {
                    props.selecteComponent({ isSmileThree: true })
                    internalaccessoriesObj.isSmileThree = true
                    resetHardwareState(['assignSmileThree'])
                    updateAccessory({ isSmileThree: true })
                    sessionStorage.setItem('isSmileThree', true)
                }
                showSnackbar('snackbar16')
                break
            }

            case 'smile4': {
                if (isM4) {
                    setFeedbackMsg(' Disable L4 to Enable Smile 4')
                    isShowFeedback(true)
                    return
                }
                if (isM4DOccupied) {
                    setFeedbackMsg(
                        'Disconnect the sensor from port M2 to enable smile4'
                    )
                    isShowFeedback(true)
                    return
                }
                if (isSmileFour) {
                    internalaccessoriesObj.isSmileFour = false
                    updateAccessory({ isSmileFour: false })
                    sessionStorage.setItem('isSmileFour', false)
                    await removeFromProgram(
                        'assignSmileFour',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueSmileFour',
                        props.indexData.logic.program
                    )
                    props.selecteComponent({ isSmileFour: false })
                    clearFlowchartOutputSessions([['s4Chk', 'sm4']])
                } else {
                    props.selecteComponent({ isSmileFour: true })
                    internalaccessoriesObj.isSmileFour = true
                    resetHardwareState(['assignSmileFour'])
                    updateAccessory({ isSmileFour: true })
                    sessionStorage.setItem('isSmileFour', true)
                }
                showSnackbar('snackbar17')
                break
            }

            case 'switch1': {
                if (isSwitch1) {
                    internalaccessoriesObj.isSwitch1 = false
                    props.selecteComponent({ isSwitch1: false })
                    sessionStorage.setItem('isSwitch1', false)
                    updateAccessory({ isSwitch1: false })
                    clearLogicSensorData(['SWITCH1'])
                    clearFlowChartIfPannelData(
                        sessionStorage.getItem('flowchart-elements'),
                        ['isSwitch1']
                    )
                    props.logicComponent(props.indexData.logic)
                } else {
                    internalaccessoriesObj.isSwitch1 = true
                    props.selecteComponent({ isSwitch1: true })
                    sessionStorage.setItem('isSwitch1', true)
                    updateAccessory({ isSwitch1: true })
                }
                showSnackbar('snackbar23')
                break
            }

            case 'switch2': {
                if (isSwitch2) {
                    internalaccessoriesObj.isSwitch2 = false
                    props.selecteComponent({ isSwitch2: false })
                    sessionStorage.setItem('isSwitch2', false)
                    updateAccessory({ isSwitch2: false })
                    clearLogicSensorData(['SWITCH2'])
                    clearFlowChartIfPannelData(
                        sessionStorage.getItem('flowchart-elements'),
                        ['isSwitch2']
                    )
                    props.logicComponent(props.indexData.logic)
                } else {
                    internalaccessoriesObj.isSwitch2 = true
                    props.selecteComponent({ isSwitch2: true })
                    sessionStorage.setItem('isSwitch2', true)
                    updateAccessory({ isSwitch2: true })
                }
                showSnackbar('snackbar24')
                break
            }

            case 'leftEye': {
                if (isLeftEye) {
                    internalaccessoriesObj.isLeftEye = false
                    updateAccessory({ isLeftEye: false })
                    await removeFromProgram(
                        'assignEye1',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'assignR1',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'assignG1',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'assignB1',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueEyeR1',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueEyeG1',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueEyeB1',
                        props.indexData.logic.program
                    )
                    props.selecteComponent({ isLeftEye: false })
                } else {
                    props.selecteComponent({ isLeftEye: true })
                    internalaccessoriesObj.isLeftEye = true
                    resetHardwareState([
                        'assignLeftEye',
                        'assignLeftEyeR',
                        'assignLeftEyeG',
                        'assignLeftEyeB',
                    ])
                    updateAccessory({ isLeftEye: true })
                }
                showSnackbar('snackbar25')
                break
            }

            case 'rightEye': {
                if (isRightEye) {
                    internalaccessoriesObj.isRightEye = false
                    updateAccessory({ isRightEye: false })
                    await removeFromProgram(
                        'assignEye2',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'assignR2',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'assignG2',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'assignB2',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueEyeR2',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueEyeG2',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueEyeB2',
                        props.indexData.logic.program
                    )
                    props.selecteComponent({ isRightEye: false })
                } else {
                    props.selecteComponent({ isRightEye: true })
                    internalaccessoriesObj.isRightEye = true
                    resetHardwareState([
                        'assignRightEye',
                        'assignRightEyeR',
                        'assignRightEyeG',
                        'assignRightEyeB',
                    ])
                    updateAccessory({ isRightEye: true })
                }
                showSnackbar('snackbar26')
                break
            }

            case 'atrMotor1': {
                if (isAtrMotor1) {
                    internalaccessoriesObj.isAtrMotor1 = false
                    updateAccessory({ isAtrMotor1: false })
                    await removeFromProgram(
                        'assignAtrMotor1M1',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'assignAtrMotor1M2',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueAtrMotor1M1',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueAtrMotor1M2',
                        props.indexData.logic.program
                    )
                    props.selecteComponent({ isAtrMotor1: false })
                } else {
                    props.selecteComponent({ isAtrMotor1: true })
                    internalaccessoriesObj.isAtrMotor1 = true
                    resetHardwareState(['assignAtrMotor1'])
                    updateAccessory({ isAtrMotor1: true })
                }
                showSnackbar('snackbar_atrMotor1')
                break
            }

            case 'atrMotor2': {
                if (isAtrMotor2) {
                    internalaccessoriesObj.isAtrMotor2 = false
                    updateAccessory({ isAtrMotor2: false })
                    await removeFromProgram(
                        'assignAtrMotor2M3',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'assignAtrMotor2M4',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueAtrMotor2M3',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueAtrMotor2M4',
                        props.indexData.logic.program
                    )
                    props.selecteComponent({ isAtrMotor2: false })
                } else {
                    props.selecteComponent({ isAtrMotor2: true })
                    internalaccessoriesObj.isAtrMotor2 = true
                    resetHardwareState(['assignAtrMotor2'])
                    updateAccessory({ isAtrMotor2: true })
                }
                showSnackbar('snackbar_atrMotor2')
                break
            }

            case 'atrMotor3': {
                if (isAtrMotor3) {
                    internalaccessoriesObj.isAtrMotor3 = false
                    updateAccessory({ isAtrMotor3: false })
                    await removeFromProgram(
                        'assignAtrMotor3E1',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'assignAtrMotor3E2',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueAtrMotor3E1',
                        props.indexData.logic.program
                    )
                    await removeFromProgram(
                        'valueAtrMotor3E2',
                        props.indexData.logic.program
                    )
                    props.selecteComponent({ isAtrMotor3: false })
                } else {
                    props.selecteComponent({ isAtrMotor3: true })
                    internalaccessoriesObj.isAtrMotor3 = true
                    resetHardwareState(['assignAtrMotor3'])
                    updateAccessory({ isAtrMotor3: true })
                }
                showSnackbar('snackbar_atrMotor3')
                break
            }

            case 'individualServo': {
                if (props.indexData.concept.internalaccessories.isIndivdualServo) {
                    internalaccessoriesObj.isIndivdualServo = false
                    props.selecteComponent({ isIndivdualServo: false })
                    sessionStorage.setItem('isIndivdualServo', false)

                    var x = document.getElementById('snackbar_woofIndividualServo')
                    x.classList.add('show')
                    setTimeout(function () {
                        x.classList.remove('show')
                    }, 1000)
                } else {
                    internalaccessoriesObj.isIndivdualServo = true
                    props.selecteComponent({ isIndivdualServo: true })
                    sessionStorage.setItem('isIndivdualServo', true)

                    var x = document.getElementById('snackbar_woofIndividualServo')
                    x.classList.add('show')
                    setTimeout(function () {
                        x.classList.remove('show')
                    }, 1000)
                }
                break
            }

            case 'actionGroup': {
                if (props.indexData.concept.internalaccessories.isActionGroup) {
                    internalaccessoriesObj.isActionGroup = false
                    props.selecteComponent({ isActionGroup: false })
                    sessionStorage.setItem('isActionGroup', false)

                    var x = document.getElementById('snackbar_woofActionGroup')
                    x.classList.add('show')
                    setTimeout(function () {
                        x.classList.remove('show')
                    }, 1000)
                } else {
                    internalaccessoriesObj.isActionGroup = true
                    props.selecteComponent({ isActionGroup: true })
                    sessionStorage.setItem('isActionGroup', true)

                    var x = document.getElementById('snackbar_woofActionGroup')
                    x.classList.add('show')
                    setTimeout(function () {
                        x.classList.remove('show')
                    }, 1000)
                }
                break
            }

            case 'oled': {
                if (props.indexData.concept.internalaccessories.isWoofOled) {
                    internalaccessoriesObj.isWoofOled = false
                    props.selecteComponent({ isWoofOled: false })
                    sessionStorage.setItem('isWoofOled', false)
                    updateAccessory({ isWoofOled: false })
                    await resetOledProgramData()
                    props.logicComponent(props.indexData.logic)

                    var x = document.getElementById('snackbar_woofOled')
                    x.classList.add('show')
                    setTimeout(function () {
                        x.classList.remove('show')
                    }, 1000)
                } else {
                    internalaccessoriesObj.isWoofOled = true
                    props.selecteComponent({ isWoofOled: true })
                    sessionStorage.setItem('isWoofOled', true)
                    updateAccessory({ isWoofOled: true })

                    var x = document.getElementById('snackbar_woofOled')
                    x.classList.add('show')
                    setTimeout(function () {
                        x.classList.remove('show')
                    }, 1000)
                }
                break
            }

            case 'ir': {
                if (isIr) {
                    internalaccessoriesObj.isIr = false
                    props.selecteComponent({ isIr: false })
                    sessionStorage.setItem('isIr', false)
                    updateAccessory({ isIr: false })
                    clearLogicSensorData(['IR'])
                    clearOledSensorSelection('isIr')
                    clearFlowChartIfPannelData(
                        sessionStorage.getItem('flowchart-elements'),
                        ['ir']
                    )
                    props.logicComponent(props.indexData.logic)
                } else {
                    internalaccessoriesObj.isIr = true
                    props.selecteComponent({ isIr: true })
                    sessionStorage.setItem('isIr', true)
                    updateAccessory({ isIr: true })
                }
                showSnackbar('ir1')
                break
            }

            case 'joystick': {
                if (isJoystick) {
                    internalaccessoriesObj.isJoystick = false
                    props.selecteComponent({ isJoystick: false })
                    sessionStorage.setItem('isJoystick', false)
                    updateAccessory({ isJoystick: false })
                    clearLogicSensorData(['JOYSTICK'])
                    clearFlowChartIfPannelData(
                        sessionStorage.getItem('flowchart-elements'),
                        ['joystick']
                    )
                    props.logicComponent(props.indexData.logic)
                } else {
                    internalaccessoriesObj.isJoystick = true
                    props.selecteComponent({ isJoystick: true })
                    sessionStorage.setItem('isJoystick', true)
                    updateAccessory({ isJoystick: true })
                }
                showSnackbar('snackbar_joystick')
                break
            }
        }
        saveToLocalStorage()
    }

    const saveToLocalStorage = () => {
        let programMode = sessionStorage.programMode
        let connectedDevice = sessionStorage.connectedDevice
        let version = sessionStorage.deviceVersion

        let updatelocalStorage = JSON.parse(
            localStorage.getItem('recoveryData')
        )
        if (updatelocalStorage) {
            if (programMode in updatelocalStorage) {
                if (connectedDevice in updatelocalStorage[programMode]) {
                    updatelocalStorage[programMode][connectedDevice][version] =
                        sessionStorage
                    localStorage.setItem(
                        'recoveryData',
                        JSON.stringify(updatelocalStorage)
                    )
                } else {
                    updatelocalStorage[programMode][connectedDevice] = {
                        [version]: sessionStorage,
                    }
                    localStorage.setItem(
                        'recoveryData',
                        JSON.stringify(updatelocalStorage)
                    )
                }
            } else {
                updatelocalStorage[programMode] = {
                    [connectedDevice]: {
                        [version]: sessionStorage,
                    },
                }
                localStorage.setItem(
                    'recoveryData',
                    JSON.stringify(updatelocalStorage)
                )
            }
        }
    }
    const backBtnAction = () => {
        setSlideDirection(true)
        sessionStorage.setItem('slideDirection', true)
        let saved = JSON.parse(sessionStorage.getItem('isSave'))
        if (saved) {
            props.history.push('/code/project')
            // window.location.reload(false)
            shouldErase('Yes')
        } else {
            setErasedProgram(true)
        }
    }

    const [isHelp, setHelp] = useState(false)

    const handleHelpBtn = (e) => {
        if (isHelp == true) {
            setHelp(false)
        } else {
            setHelp(true)
        }
    }

    const shouldErase = (info) => {
        if (info == 'Yes') {
            let programMode = sessionStorage.programMode
            let connectedDevice = sessionStorage.connectedDevice
            let version = sessionStorage.deviceVersion
            let recoveryData = JSON.parse(localStorage.getItem('recoveryData'))
            sessionStorage.setItem('isSave', JSON.stringify(false))
            if (
                localStorage.getItem('recoveryData') !== null &&
                programMode in recoveryData &&
                connectedDevice in recoveryData[programMode] &&
                version in recoveryData[programMode][connectedDevice]
            ) {
                delete recoveryData[programMode][connectedDevice][version]
                if (
                    Object.keys(recoveryData[programMode][connectedDevice])
                        .length === 0
                ) {
                    delete recoveryData[programMode][connectedDevice]
                }
                if (Object.keys(recoveryData[programMode]).length === 0) {
                    delete recoveryData[programMode]
                }
                if (Object.keys(recoveryData).length === 0) {
                    localStorage.removeItem('recoveryData')
                } else {
                    localStorage.setItem(
                        'recoveryData',
                        JSON.stringify(recoveryData)
                    )
                }
            }
            if (programMode === 'flowchartBased') {
                const keepKeys = [
                    'connectedDevice',
                    'Hardware',
                    'userData',
                    'concept',
                    'webSerialPortList',
                    'user',
                    'deviceVersion',
                    'programMode',
                    'isWindowOnFocus',
                    'slideDirection',
                    'assembly',
                    'microPython',
                ]
                Object.keys(sessionStorage).forEach((key) => {
                    if (!keepKeys.includes(key)) sessionStorage.removeItem(key)
                })
                props.history.push('/flow')
            } else {
                sessionStorage.removeItem('programEnd')
                sessionStorage.removeItem('PET')
                sessionStorage.removeItem('EndSwitch')
                sessionStorage.setItem('pip', false)
                sessionStorage.setItem('name', 'null')
                sessionStorage.removeItem('Index')
                sessionStorage.setItem('shield', 'false')
                props.clearComponentSelection()
                props.history.push('/code/project')
            }
            sessionStorage.setItem('peeCeeATR', 'false')
            const sessionRemoveKeys = [
                'flowchart-elements',
                'isMic',
                'isTemperature',
                'isAccelerometer',
                'isTouchZero',
                'isTouchZeroOutput',
                'isTouchOne',
                'isInternalEye',
                'isTouchOneOutput',
                'isTouchTwo',
                'isTouchTwoOutput',
                'isTouchThreeOutput',
                'isTouchThree',
                'isColorSensor',
                'isBattery',
                'isGestureSensor',
                'isLightSensor',
                'isDistanceSensors',
                'isSmileOne',
                'isSmileTwo',
                'isSmileThree',
                'isSmileFour',
                'isBuzzer',
                'isSwitch1',
                'isSwitch2',
                'isAtrMotor1',
                'isAtrMotor2',
                'isAtrMotor3',
                'isIr',
            ]
            sessionRemoveKeys.forEach((key) => sessionStorage.removeItem(key))

            props.DeselectedComponent({
                ...internalaccessoriesObj,
                Four_in_one_sensor: {
                    isDistanceSensors: false,
                    isGestureSensor: false,
                    isLightSensor: false,
                    isColorSensor: false,
                },
                isFour_in_one_sensor: false,
            })

            props.setAssemblyPageAi(defaultAssemblyPageAi)
        } else {
            setErasedProgram(false)
        }
    }

    const next = () => {
        setSlideDirection(false)
        sessionStorage.setItem('slideDirection', false)
        let programMode = sessionStorage.programMode
        let connectedDevice = sessionStorage.connectedDevice
        let version = sessionStorage.deviceVersion

        if (localStorage.getItem('recoveryData') === null) {
            localStorage.setItem(
                'recoveryData',
                JSON.stringify({
                    [programMode]: {
                        [connectedDevice]: {
                            [version]: sessionStorage,
                        },
                    },
                })
            )
        } else {
            let updatelocalStorage = JSON.parse(
                localStorage.getItem('recoveryData')
            )
            if (programMode in updatelocalStorage) {
                if (connectedDevice in updatelocalStorage[programMode]) {
                    updatelocalStorage[programMode][connectedDevice][version] =
                        sessionStorage
                    localStorage.setItem(
                        'recoveryData',
                        JSON.stringify(updatelocalStorage)
                    )
                } else {
                    updatelocalStorage[programMode][connectedDevice] = {
                        [version]: sessionStorage,
                    }
                    localStorage.setItem(
                        'recoveryData',
                        JSON.stringify(updatelocalStorage)
                    )
                }
            } else {
                updatelocalStorage[programMode] = {
                    [connectedDevice]: {
                        [version]: sessionStorage,
                    },
                }
                localStorage.setItem(
                    'recoveryData',
                    JSON.stringify(updatelocalStorage)
                )
            }
        }
        // woofKit reaches the Select screens via the expansion-kit path, which
        // (unlike the standard Selection > "Program" button flow) never sets
        // localStorage programMode. The concept External Accessories page and
        // its Next button both require programMode === 'program', so set it here
        // for woofKit — mirroring what Selection.js programBtn does for Poki.
        if (sessionStorage.getItem('connectedDevice') === 'woofKit') {
            localStorage.setItem('programMode', 'program')
        }
        if (sessionStorage.getItem('programMode') === 'flowchartBased')
            history.push('/flow/selectports')
        else history.push('/selectScreen/ExternalAccessories')
    }

    sessionStorage.setItem('assemblyCheckbox', JSON.stringify(null))

    useEffect(() => {
        if (
            isDistanceSensors ||
            isGestureSensor ||
            isLightSensor ||
            isColorSensor
        ) {
            internalaccessoriesObj.isFour_in_one_sensor = true
            props.selecteComponent({ isFour_in_one_sensor: true })
        } else {
            internalaccessoriesObj.isFour_in_one_sensor = false
            props.selecteComponent({ isFour_in_one_sensor: false })
        }
    }, [isDistanceSensors, isGestureSensor, isLightSensor, isColorSensor])

    // Caching External Component assets

    useEffect(() => {
        let assetsToBeCached = [
            renderCompImg('Audio_codec'),
            renderCompImg('pot'),
            renderCompImg('play_shield'),
            renderCompImg('play_shield_v1_top'),
            renderCompImg('play_shield_top'),
            renderCompImg('dc_motor'),
            renderCompImg('dynamex_motor'),
            renderCompImg('geared_motor'),
            renderCompImg('mini_geared_motor'),
            renderCompImg('distance_sensor'),
            renderCompImg('dual_switch'),
            renderCompImg('joystick'),
            renderCompImg('joystick_v2'),
            renderCompImg('laser'),
            renderCompImg('led'),
            renderCompImg('servo_motor'),
            renderCompImg('servo_motor_270'),
            renderCompImg('servo_motor_360'),
            renderCompImg('light_sensor'),
            renderCompImg('tact_switch'),
            renderCompImg('touch_sensor'),
            renderCompImg('ultrasonic_sensor'),
            renderCompImg('led_1c'),
            renderCompImg('tact_switch_2c'),
            renderCompImg('RGB'),
            renderCompImg('OLED'),
            renderCompImg('mp3'),
            renderCompImg('dip_switch'),
            renderCompImg('linear_pot'),
            renderCompImg('humidity'),
            renderCompImg('metal_detector'),
            renderCompImg('extender'),
            renderCompImg('temperature_sensor'),
            renderCompImg('gas'),
            renderCompImg('rain_sensor'),
            renderCompImg('pc_motor_driver'),
            renderCompImg('dual_splitter'),
            // helpscreen
            renderPrgImage('InternalPrgf1'),
            renderPrgImage('InternalPrgf2'),
            renderPrgImage('InternalPrgf3'),
            renderPrgImage('InternalPrgf4'),
            renderPrgImage('Pcv1SelectH1'),
            renderPrgImage('Pcv1SelectH2'),
            renderPrgImage('ExternalPrgf2'),
            renderPrgImage('ExternalPrgf3'),
            renderPrgImage('assemblyH'),
            renderPrgImage('Pcv1AssemblyH'),
            renderPrgImage('AssemblyPrgf1'),
            renderPrgImage('assemblyH2'),
            renderPrgImage('Pcv1AssemblyH2'),
            renderPrgImage('AssemblyPrgf2'),
            renderPrgImage('assemblyH3'),
            renderPrgImage('Pcv1AssemblyH3'),
            renderPrgImage('AssemblyPrgf3'),
            renderPrgImage('AssemblyPrgf4'),
            renderPrgImage('LogicPrgf1'),
            renderPrgImage('LogicPrgf2'),
            renderPrgImage('LogicPrgf3'),
            renderPrgImage('LogicPrgf4'),
            renderPrgImage('LogicPrgf5'),
        ]
        cacheAssets(assetsToBeCached)
    }, [])

    return (
        <>
            <Toast
                show={showFeedback}
                message={feedbackMsg}
                onClose={() => isShowFeedback(false)}
            />
            <DialogModal
                show={erasedProgram}
                text="All Unsaved program will be Erased. Are you sure want to continue ?"
                showCloseBtn={false}
                optionsToSelect={[
                    {
                        text: 'YES',
                        do: () => shouldErase('Yes'),
                    },
                    {
                        text: 'NO',
                        do: () => shouldErase('No'),
                    },
                ]}
            />
            <div className="InternalAccessoriesScreen_Main_v1">
                <div>
                    <ProgramHeader
                        data={{
                            options: getHederTextArr({
                                languageName,
                                keyArr: ['Select', 'Assemble', 'Code', ''],
                            }),
                            selected: 0,
                        }}
                        showSave={true}
                        showHelp={true}
                        handleHelp={handleHelpBtn}
                        showAiBtn={true}
                    />
                </div>

                <div
                    className={`${
                        slideDirection === 'true' ? 'slide-right' : ''
                    }`}
                >
                    {' '}
                    <div className="Item-1_v1">
                        <div className="InternalAccessoriesScreen-Item1_v1">
                            <div style={styleDevicePC} className="device_v1">
                                {['Roboki'].includes(connectedDevice) && (
                                    <div className="deviceContainer_v1">
                                        {deviceOverlayConfig.robokiEyes.map(
                                            (eye) => (
                                                <img
                                                    key={eye.stateKey}
                                                    src={renderPrgImage(
                                                        props.indexData.concept
                                                            .internalaccessories[
                                                            eye.stateKey
                                                        ]
                                                            ? 'PcinternalEYEActive_v1'
                                                            : 'PcinternalEYEInActive_v1'
                                                    )}
                                                    className="imgStyleTeeth_v1"
                                                    style={eye.style}
                                                    draggable="false"
                                                />
                                            )
                                        )}
                                    </div>
                                )}{' '}
                                {['Atr'].includes(connectedDevice) && (
                                    <div className="deviceContainer_v1"></div>
                                )}{' '}
                                {![
                                    'Roboki',
                                    'Autoki',
                                    'Atr',
                                    'Moki',
                                    'Toki',
                                    'Poki',
                                    'woofKit',
                                ].includes(connectedDevice) && (
                                    <div className="deviceContainer_v1">
                                        <div>
                                            {deviceOverlayConfig.peeCeeEyePositions.map(
                                                (value, index) => (
                                                    <div key={index}>
                                                        {deviceOverlayConfig.peeCeeEyeRows.map(
                                                            (top) => (
                                                                <img
                                                                    key={top}
                                                                    src={renderPrgImage(
                                                                        props
                                                                            .indexData
                                                                            .concept
                                                                            .internalaccessories
                                                                            .isEYES
                                                                            ? 'PcinternalEYEActive_v1'
                                                                            : 'PcinternalEYEInActive_v1'
                                                                    )}
                                                                    className="imgStyleEye_v1"
                                                                    style={{
                                                                        left: `${value}%`,
                                                                        top,
                                                                    }}
                                                                    draggable="false"
                                                                />
                                                            )
                                                        )}
                                                    </div>
                                                )
                                            )}
                                        </div>

                                        {deviceOverlayConfig.peeCeeTeeth.map(
                                            (tooth) => (
                                                <img
                                                    key={tooth.stateKey}
                                                    src={renderPrgImage(
                                                        props.indexData.concept
                                                            .internalaccessories[
                                                            tooth.stateKey
                                                        ]
                                                            ? 'PcinternalTeethActive_v1'
                                                            : 'PcinternalTeethInActive_v1'
                                                    )}
                                                    className="imgStyleTeeth_v1"
                                                    style={tooth.style}
                                                    draggable="false"
                                                />
                                            )
                                        )}

                                        <img
                                            src={renderPrgImage(
                                                FOUR_IN_ONE_KEYS.some(
                                                    (k) =>
                                                        props.indexData.concept
                                                            .internalaccessories
                                                            .Four_in_one_sensor[
                                                            k
                                                        ]
                                                )
                                                    ? 'Pcinternal4in1Active_v1'
                                                    : 'Pcinternal4in1InActive_v1'
                                            )}
                                            className="imgStyle4in1_v1"
                                            style={
                                                deviceOverlayConfig.peeCee4in1
                                                    .style
                                            }
                                            draggable="false"
                                        />

                                        <img
                                            src={renderPrgImage(
                                                props.indexData.concept
                                                    .internalaccessories.isMic
                                                    ? 'PcinternalMicActive'
                                                    : 'PcinternalMicInActive'
                                            )}
                                            className="imgStyleMic_v1"
                                            style={
                                                deviceOverlayConfig.peeCeeMic
                                                    .style
                                            }
                                            draggable="false"
                                        />

                                        <img
                                            src={renderPrgImage(
                                                props.indexData.concept
                                                    .internalaccessories
                                                    .isbuzzer
                                                    ? 'PcinternalBuzzerActive'
                                                    : 'PcinternalBuzzerInActive'
                                            )}
                                            className="imgStyleBuzzer_v1"
                                            style={
                                                deviceOverlayConfig.peeCeeBuzzer
                                                    .style
                                            }
                                            draggable="false"
                                        />

                                        {deviceOverlayConfig.touchpads.map((pad, index) => {
                                            if (!isInternalAccessoryEnabled(`touch-pad-${index}`)) return null;
                                            const isActive = props.indexData.concept.internalaccessories[pad.inputKey] || props.indexData.concept.internalaccessories[pad.outputKey];
                                            return (
                                                <img
                                                    key={pad.inputKey}
                                                    className={pad.className}
                                                    style={{
                                                        ...pad.style,
                                                        background: isActive ? deviceOverlayConfig.activeColor : deviceOverlayConfig.inactiveColor
                                                    }}
                                                    draggable="false"
                                                />
                                            )
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="InternalAccessoriesScreen-Item2_v1">
                            {connectedDevice !== 'Atr' &&
                                connectedDevice !== 'woofKit' && (
                                <div className="input_v1 input_one_v1">
                                    <p
                                        className="inputText_v1"
                                        style={{
                                            fontFamily: 'Halcyon_SemiBold',
                                        }}
                                    >
                                        Inputs
                                    </p>
                                    <div className="inputContiner_v1">
                                        {DEVICE_GROUPS.robokiFamily.includes(connectedDevice) && (
                                            <div className="container-row_v1 ">
                                                {inputRowOneConfig.map((item) => {
                                                    if (item.visibleDevices && !item.visibleDevices.includes(connectedDevice)) return null;
                                                    if (item.hiddenDevices && item.hiddenDevices.includes(connectedDevice)) return null;

                                                    const accessoryKeyMap = { ir: 'ir-sensor', switch1: 'switch-1', switch2: 'switch-2' };
                                                    if (!isInternalAccessoryEnabled(accessoryKeyMap[item.alt])) return null;

                                                    const isActive = props.indexData.concept.internalaccessories[item.key];
                                                    return (
                                                        <img
                                                            key={item.key}
                                                            src={renderPrgImage(isActive ? item.activeImg : item.inactiveImg)}
                                                            className="imgStyle_v1"
                                                            alt={item.alt}
                                                            onClick={handleEventsClick}
                                                        />
                                                    );
                                                })}
                                            </div>
                                        )}
                                        
                                        {!DEVICE_GROUPS.robokiFamily.includes(connectedDevice) && (
                                            <div className="container-row_v1 ">
                                                {inputRowTwoConfig.map((item) => {
                                                    if (!isInternalAccessoryEnabled(item.alt)) return null;
                                                    const isActive = props.indexData.concept.internalaccessories[item.key];
                                                    return (
                                                        <img
                                                            key={item.key}
                                                            src={renderPrgImage(isActive ? item.activeImg : item.inactiveImg)}
                                                            className="imgStyle_v1"
                                                            alt={item.alt}
                                                            onClick={handleEventsClick}
                                                            // style={item.style || {}}
                                                        />
                                                    );
                                                })}
                                            </div>
                                        )}

                                        {!DEVICE_GROUPS.robokiFamily.includes(connectedDevice) && (
                                            <div className="container-row_v1">
                                                {inputTouchPadConfig.map((item) => {
                                                    const isActive = props.indexData.concept.internalaccessories[item.key];
                                                    const isDisabled = item.disableSessionKey && JSON.parse(sessionStorage.getItem(item.disableSessionKey)) === true;
                                                    return (
                                                        <img
                                                            key={item.key}
                                                            src={renderPrgImage(isActive ? item.activeImg : item.inactiveImg)}
                                                            className={`imgStyle_v1 ${isDisabled ? 'isDisableBtn' : ''}`}
                                                            alt={item.alt}
                                                            onClick={handleEventsClick}
                                                            // style={item.style || {}}
                                                        />
                                                    );
                                                })}
                                            </div>
                                        )}

                                        {!DEVICE_GROUPS.robokiFamily.includes(connectedDevice) && (
                                            <div className="container-row_v1">
                                                {inputFourInOneSensorConfig.map((item) => {
                                                    if (item.hideWhen2In1 && props.indexData.device.is2In1Sensor) return null;
                                                    const isActive = props.indexData.concept.internalaccessories.Four_in_one_sensor[item.key];
                                                    return (
                                                        <img
                                                            key={item.key}
                                                            src={renderPrgImage(isActive ? item.activeImg : item.inactiveImg)}
                                                            className="imgStyle_v1"
                                                            alt={item.alt}
                                                            onClick={handleFounInOneSensor}
                                                        />
                                                    );
                                                })}
                                            </div>
                                        )}

                                        {snackbarConfig.map(
                                            ({
                                                id,
                                                stateKey,
                                                prefix,
                                                label,
                                            }) => (
                                                <div key={id} id={id}>
                                                    {`${prefix} - ${label} ${stateMap[stateKey] ? 'selected' : 'deselected'}`}
                                                </div>
                                            )
                                        )}
                                        {snackbarWarningConfig.map(
                                            ({ id, conditionKeys, message }) =>
                                                conditionKeys.some(
                                                    (k) => stateMap[k]
                                                ) ? null : (
                                                    <div
                                                        key={id}
                                                        id={id}
                                                    >{` ${message}`}</div>
                                                )
                                        )}
                                        {snackbarDeviceConfig.map((item) => {
                                            const prefix =
                                                item.useConnectedDevice
                                                    ? connectedDevice
                                                    : item.devicePrefixMap?.[
                                                          connectedDevice
                                                      ] ||
                                                      item.devicePrefixMap
                                                          ?.default
                                            const style =
                                                item.mobileDevices?.includes(
                                                    connectedDevice
                                                )
                                                    ? item.mobileStyle || {}
                                                    : item.style || {}
                                            const isActive =
                                                stateMap[item.stateKey]
                                            const deselectedLabel =
                                                item.deselectedLabel ||
                                                item.label.toLowerCase()
                                            return (
                                                <div
                                                    key={item.id}
                                                    id={item.id}
                                                    style={style}
                                                >
                                                    {`${prefix} - ${isActive ? item.label : deselectedLabel} ${isActive ? 'selected' : 'deselected'}`}
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            )}

                            {snackbarBottomConfig.map(
                                ({ id, stateKey, prefix, label }) => (
                                    <div key={id} id={id} className="bottom0">
                                        {`${prefix} - ${label} ${stateMap[stateKey] ? 'selected' : 'deselected'}`}
                                    </div>
                                )
                            )}
                            {Object.keys(
                                outPutData?.ATR1?.row1?.internalComponents || {}
                            ).map((objKey) => {
                                const toast = tostMessages[objKey]
                                if (!toast) return null
                                return (
                                    <div
                                        key={toast.tostDivId}
                                        id={toast.tostDivId}
                                        className={toast.tostDivClass}
                                    >
                                        {`Atr - ${stateMap[outPutData.ATR1.row1.internalComponents[objKey].reduxName] ? toast.activeMessage.trim() : toast.InactiveMessage.trim()}`}
                                    </div>
                                )
                            })}
                            {isRightEye ? (
                                <div id="snackbar26" className="bottom0">
                                    Roboki - Right Eye selected
                                </div>
                            ) : (
                                <div id="snackbar26" className="bottom0">
                                    Roboki - Right Eye deselected
                                </div>
                            )}
                            {!DEVICE_GROUPS.mobileDevices.includes(
                                connectedDevice
                            ) &&
                                connectedDevice !== 'woofKit' && (
                                <div className="input_v1 input_one_v1">
                                    <p className="inputText_v1">Outputs</p>
                                    <div className="inputContiner_v1 outputGrid_v1">
                                        {['Roboki'].includes(connectedDevice) && (
                                            <div className="container-row_v1">
                                                {outputRobokiEyesConfig.map((item) => {
                                                    const isActive = props.indexData.concept.internalaccessories[item.key];
                                                    return (
                                                        <img
                                                            key={item.key}
                                                            style={connectedDevice === 'Atr' ? { height: 'auto' } : {}}
                                                            src={renderPrgImage(isActive ? item.activeImg : item.inactiveImg)}
                                                            className="imgStyle_v1"
                                                            alt={item.alt}
                                                            onClick={handleEventsClick}
                                                        />
                                                    );
                                                })}
                                            </div>
                                        )}
                                        {connectedDevice === 'Atr' && (
                                            <div className="container-row_v1">
                                                {Object.keys(
                                                    outPutData?.ATR1?.row1
                                                        ?.internalComponents
                                                ).map((objKey) => {
                                                    let imageDetails =
                                                        outPutData?.ATR1?.row1
                                                            ?.internalComponents?.[
                                                            objKey
                                                        ]
                                                    return (
                                                        <img
                                                            key={objKey}
                                                            style={
                                                                imageDetails.imgTagStyle
                                                            }
                                                            src={
                                                                props.indexData
                                                                    .concept
                                                                    .internalaccessories[
                                                                    imageDetails
                                                                        .reduxName
                                                                ]
                                                                    ? renderImage(
                                                                          imageDetails.activeImgSrc
                                                                      )
                                                                    : renderImage(
                                                                          imageDetails.inActiveImgSrc
                                                                      )
                                                            }
                                                            className={
                                                                imageDetails.ImgClassName
                                                            }
                                                            alt={
                                                                imageDetails.altText
                                                            }
                                                            onClick={
                                                                handleEventsClick
                                                            }
                                                        />
                                                    )
                                                })}
                                            </div>
                                        )}
                                        
                                        {!['Roboki', 'Atr'].includes(connectedDevice) && !isHumanoidWithoutRGB && (
                                            <div className="container-row_v1">
                                                {outputPeeCeeRow1Config.map((item) => {
                                                    const isActive = props.indexData.concept.internalaccessories[item.key];
                                                    return (
                                                        <img
                                                            key={item.key}
                                                            src={renderPrgImage(isActive ? item.activeImg : item.inactiveImg)}
                                                            className="imgStyle_v1"
                                                            alt={item.alt}
                                                            onClick={handleEventsClick}
                                                        />
                                                    );
                                                })}
                                            </div>
                                        )}

                                        {!['Roboki', 'Atr', 'Autoki'].includes(connectedDevice) && (
                                            <div className="container-row_v1">
                                                {outputTouchPadConfig.map((item) => {
                                                    const isActive = props.indexData.concept.internalaccessories[item.key];
                                                    const isDisabled = item.disableSessionKey && JSON.parse(sessionStorage.getItem(item.disableSessionKey)) === true;
                                                    return (
                                                        <img
                                                            key={item.key}
                                                            src={renderPrgImage(isActive ? item.activeImg : item.inactiveImg)}
                                                            className={`imgStyle_v1 ${isDisabled ? 'isDisableBtn' : ''}`}
                                                            alt={item.alt}
                                                            onClick={handleEventsClick}
                                                        />
                                                    );
                                                })}
                                            </div>
                                        )}

                                        {!['Roboki', 'Atr', 'Autoki'].includes(connectedDevice) && (
                                            <div className="container-row_v1">
                                                {outputSmileConfig.map((item) => {
                                                    const isActive = props.indexData.concept.internalaccessories[item.key];
                                                    return (
                                                        <img
                                                            key={item.key}
                                                            src={renderPrgImage(isActive ? item.activeImg : item.inactiveImg)}
                                                            className="imgStyle_v1"
                                                            alt={item.alt}
                                                            onClick={handleEventsClick}
                                                        />
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* ---------- woofKit dedicated Inputs / Outputs ---------- */}
                            {connectedDevice === 'woofKit' && (
                                <>
                                    <div className="input_v1 input_one_v1">
                                        <p
                                            className="inputText_v1"
                                            style={{
                                                fontFamily: 'Halcyon_SemiBold',
                                            }}
                                        >
                                            Inputs
                                        </p>
                                        <div className="inputContiner_v1">
                                            <div className="container-row_v1">
                                                {props.indexData.concept
                                                    .internalaccessories
                                                    .isIr ? (
                                                    <img
                                                        src={renderPrgImage(
                                                            'irActive'
                                                        )}
                                                        className="imgStyle_v1"
                                                        alt="ir"
                                                        onClick={
                                                            handleEventsClick
                                                        }
                                                    />
                                                ) : (
                                                    <img
                                                        src={renderPrgImage(
                                                            'irInActive'
                                                        )}
                                                        className="imgStyle_v1"
                                                        alt="ir"
                                                        onClick={
                                                            handleEventsClick
                                                        }
                                                    />
                                                )}
                                            </div>
                                            {isIr ? (
                                                <div id="ir1">
                                                    woofKit - Ir selected
                                                </div>
                                            ) : (
                                                <div id="ir1">
                                                    woofKit - Ir deselected
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="input_v1 input_one_v1">
                                        <p className="inputText_v1">Outputs</p>
                                        <div className="inputContiner_v1 outputGrid_v1">
                                            <div className="container-row_v1">
                                                {Object.keys(
                                                    outPutData?.WOOFKIT1?.row1
                                                        ?.internalComponents
                                                ).map((objKey) => {
                                                    let imageDetails =
                                                        outPutData?.WOOFKIT1
                                                            ?.row1
                                                            ?.internalComponents?.[
                                                            objKey
                                                        ]
                                                    return (
                                                        <img
                                                            key={objKey}
                                                            style={
                                                                imageDetails.imgTagStyle
                                                            }
                                                            src={
                                                                props.indexData
                                                                    .concept
                                                                    .internalaccessories[
                                                                    imageDetails
                                                                        .reduxName
                                                                ]
                                                                    ? renderImage(
                                                                          imageDetails.activeImgSrc
                                                                      )
                                                                    : renderImage(
                                                                          imageDetails.inActiveImgSrc
                                                                      )
                                                            }
                                                            className={
                                                                imageDetails.ImgClassName
                                                            }
                                                            alt={
                                                                imageDetails.altText
                                                            }
                                                            onClick={
                                                                handleEventsClick
                                                            }
                                                        />
                                                    )
                                                })}
                                            </div>
                                            <div
                                                id="snackbar_woofIndividualServo"
                                                className="bottom0"
                                            >
                                                {props.indexData.concept
                                                    .internalaccessories
                                                    .isIndivdualServo
                                                    ? 'woofKit - Individual Servo selected'
                                                    : 'woofKit - Individual Servo deselected'}
                                            </div>
                                            <div
                                                id="snackbar_woofActionGroup"
                                                className="bottom0"
                                            >
                                                {props.indexData.concept
                                                    .internalaccessories
                                                    .isActionGroup
                                                    ? 'woofKit - Action Group selected'
                                                    : 'woofKit - Action Group deselected'}
                                            </div>
                                            <div
                                                id="snackbar_woofOled"
                                                className="bottom0"
                                            >
                                                {props.indexData.concept
                                                    .internalaccessories
                                                    .isWoofOled
                                                    ? 'woofKit - OLED selected'
                                                    : 'woofKit - OLED deselected'}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>

                <div>
                    {sessionStorage.getItem('programMode') ===
                    'projectBased' ? (
                        <Footer
                            isGoBack={false}
                            goBack={backBtnAction}
                            title={
                                'Select the internal accessories of ' + getConnectedDeviceName()
                            }
                            isGoNext={true}
                            goNext={next}
                        />
                    ) : (
                        <div className="SelectScreenBottom">
                            <div className="bottom-child">
                                <img
                                    className="iconBtnSize imgBackBtn"
                                    src={renderPrgImage('backBtn')}
                                    onClick={backBtnAction}
                                />
                                <div
                                    style={{
                                        fontFamily: 'Halcyon_SemiBold',
                                        color: 'rgb(112, 112, 112)',
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%,-50%)',
                                    }}
                                >
                                    <p>
                                        Select the internal accessories of{' '}
                                        {getConnectedDeviceName()}
                                    </p>
                                </div>

                                <img
                                    className="iconBtnSize imgNextBtn"
                                    src={renderPrgImage('nextBtn')}
                                    onClick={next}
                                />
                            </div>
                        </div>
                    )}
                </div>
                <div>
                    {isHelp && (
                        <div
                            className="Ss_slide"
                            style={{
                                top: '49vh%',
                                left: '50%',
                                width: '101vw',
                                transform: 'translate(-50%,-50%)',
                            }}
                        >
                            {' '}
                            <InternalScPrgm />{' '}
                            <img
                                className="helpClo"
                                src={renderPrgImage('closBtn')}
                                onClick={handleHelpBtn}
                            ></img>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        indexData: state,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        selecteComponent: (data) => {
            dispatch({ type: 'INTERNAL_ACCESSORIES', payload: data })
        },
        DeselectedComponent: (data) => {
            dispatch({ type: 'INTERNAL_ACCESSORIES', payload: data })
        },
        logicComponent: (data) => {
            dispatch({ type: 'LOGIC_SELECTION', payload: data })
        },
        webSerialConnect: (data) => {
            dispatch(webSerialConnect(data))
        },
        setAssemblyPageAi: (data) => {
            dispatch({ type: 'ASSEMBLY_PAGE_AI', payload: data })
        },
        clearComponentSelection: (data) => {
            dispatch({ type: 'CLEAR_COMPONENT_SELECTION' })
        },
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InternalAccessoriesScreen_v1)